import React, { useEffect, useState } from "react";
import "./LiveTournamentToolTable.css";
import StatTable from "../../../../../StatTable";
import PlayerInfoDisplay from "../LiveScorecards/PlayerInfoDisplay";
import { colorGradient, getColorGradientValue } from "../../../../../../Utils";
import { instanceOf } from "prop-types";

export default function LiveTournamentToolTable({
  data,
  columns,
  myPlayerIds,
  roundNumber,
  showDrawer = true,
  minMaxVals = undefined,
  showDKPlayerInfo = undefined,
}) {
  const renderPlayerDrawer = React.useCallback(({ row }) => {
    if (!row.original.scorecardId) {
      return;
    }

    return (
      <PlayerInfoDisplay
        scorecardId={row.original.scorecardId}
        roundNumber={roundNumber}
      />
    );
  }, []);

  return (
    <StatTable
      data={data}
      columns={columns}
      showDKPlayerInfo={showDKPlayerInfo}
      getCellProps={(cellInfo) => {
        if (
          ["Player", "To Par", "Tot", "Rd"].includes(cellInfo.column.Header)
        ) {
          const style = {};

          const rowPlayerId = cellInfo.row.original.playerId;

          if (myPlayerIds.includes(rowPlayerId)) {
            style.backgroundColor = "#ffff99";
          }

          return {
            style: style,
          };
        } else {
          let cellVal = cellInfo.value;

          if (typeof cellVal === "string" && cellVal.includes("%")) {
            cellVal = parseFloat(cellVal.replace("%", ""));
          }

          const colorVal = getColorGradientValue(
            minMaxVals,
            cellInfo.column.id,
            cellVal,
            cellInfo.column.sortDescFirst
          );

          if (colorVal) {
            return {
              style: {
                backgroundColor: colorVal,
              },
            };
          }
        }
      }}
      renderRowSubComponent={showDrawer ? renderPlayerDrawer : null}
    />
  );
}
